import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import i18n from "@swa-ui/locale";
import { classNames } from "@swa-ui/string";

import { EmailFormField, emailFormFieldPropTypes } from "../EmailFormField";
import styles from "./ConfirmEmailFormFields.module.scss";
import { CONFIRM_EMAIL_SCHEMA_FIELDS_NAME } from "./ConfirmEmailFormFields.schema";

/**
 * ConfirmEmailFormFields provides support for a standard Input component to be used as
 * two email fields that validate each other in a Form.
 */

export const ConfirmEmailFormFields = (props) => {
  const { className, componentProps, confirmEmailFormFieldProps, emailFormFieldProps } = props;

  return (
    <div className={classNames(styles.layout, className)}>
      <EmailFormField {...getEmailFormFieldProps()} />
      <EmailFormField {...getConfirmEmailFormFieldProps()} />
    </div>
  );

  function getEmailFormFieldProps() {
    return {
      ...emailFormFieldProps,
      label: i18n("ConfirmEmailFormFields__LABEL"),
      name: CONFIRM_EMAIL_SCHEMA_FIELDS_NAME.email,
    };
  }

  function getConfirmEmailFormFieldProps() {
    return {
      ...confirmEmailFormFieldProps,
      componentProps: {
        "aria-label": i18n("ConfirmEmailFormFields__ARIA_CONFIRMATION"),
        ...componentProps,
        type: "email",
      },
      label: i18n("ConfirmEmailFormFields__LABEL_CONFIRMATION"),
      name: CONFIRM_EMAIL_SCHEMA_FIELDS_NAME.confirmEmail,
    };
  }
};

export const confirmEmailFormFieldsPropTypes = {
  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Component props for confirmation EmailFormField component. */
  confirmEmailFormFieldProps: PropTypes.shape(emailFormFieldPropTypes),

  /** Component props for EmailFormField component. */
  emailFormFieldProps: PropTypes.shape(emailFormFieldPropTypes),
};

ConfirmEmailFormFields.propTypes = confirmEmailFormFieldsPropTypes;
